import React, { useEffect } from 'react';
import './conteudo-painel-whatsapp.component.scss';
import { Box, Button, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, Tabs, TextField } from '@mui/material';
import Tab from '@mui/material/Tab';
import { useInput } from '../../hooks/useInput.hook';
import AttachmentModalComponent from '../attachment-modal/attachment-modal.component';
import MenuModel, { ItensMenuModel } from '../../models/menu.model';
import { CONSTANTS } from '../../constants/constants';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import AddIcon from '@mui/icons-material/Add';

import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CamposMenuComponent from '../campos-menu/campos-menu.component';
import { SalvarPainelService } from '../../services/salvar-painel.service';
import WhatsAppModel from '../../models/whatsapp.model';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

type ConteudoPainelWhatsappComponentProps = {
  setVal: (val: WhatsAppModel) => void;
  whatsapp?: WhatsAppModel;
}

function ConteudoPainelWhatsappComponent(props: ConteudoPainelWhatsappComponentProps) {

  const [breveTextoInput, setBreveTextoInput] = React.useState(props.whatsapp?.texto);
  const [celularInput, setCelularInput] = React.useState(props.whatsapp?.celular);

  const [valueTabs, setValueTabs] = React.useState(0);

  SalvarPainelService.getSalvar().subscribe(() => {
    handleChangeItem();
  });

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  const handleChangeItem = () => {
    props.setVal({
      texto: breveTextoInput ? breveTextoInput : '',
      celular: celularInput ? celularInput : '',
    });
  }

  return (
    <section className="conteudo-painel-whatsapp">
      <Box sx={{ width: '100%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs
            value={valueTabs}
            onChange={handleChange}
            aria-label="basic tabs example">
            <Tab label="Geral" {...a11yProps(0)} />
          </Tabs>
        </Box>
        <CustomTabPanel value={valueTabs} index={0}>
          <h2>Whatsapp</h2>
          <TextField rows={3} multiline value={breveTextoInput} onChange={(event) => setBreveTextoInput(event.target.value)} label="Breve texto" className='w100' />
          <TextField value={celularInput} onChange={(event) => setCelularInput(event.target.value)} label="Celular (Prefixo + DDD)" className='w100' />
          <p className='legenda-cel'>
            Celular (Prefixo + DDD) <br />
            <strong>Exemplo:</strong> 5511999999999
          </p>
        </CustomTabPanel>
      </Box>
    </section>
  );
}

export default ConteudoPainelWhatsappComponent;
